module.exports = __webpack_public_path__ + "static/media/MHeiSungHK-UltraBold.c8c5c0da.svg";